export const ISO_CLAUSES = [
  "Clause 4: Context of the Organization",
  "Clause 5: Leadership",
  "Clause 6: Planning",
  "Clause 7: Support",
  "Clause 8: Operation",
  "Clause 9: Performance Evaluation",
  "Clause 10: Improvement",
];

export const ISO_ANNEX_A_CATEGORIES = [
  { name: "Organizational Controls", count: 37 },
  { name: "People Controls", count: 8 },
  { name: "Physical Controls", count: 14 },
  { name: "Technological Controls", count: 34 },
];

export const ISO27001_CATALOG = [
  {
    controlId: "A.5.1",
    clause: "Clause 5: Leadership",
    domain: "Organizational",
    controlObjective: "Policies for information security",
    controlStatement: "Information security policy set shall be defined, approved, published and communicated.",
    implementationGuidance: "Maintain policy lifecycle, ownership, and review cadence.",
    rbiMapping: "RBI-GOV-01",
    sebiMapping: "CSCRF-GOV-01",
    evidence: "Approved policies, Board minutes, version history",
    auditMethod: "Document inspection, interviews",
  },
  {
    controlId: "A.5.15",
    clause: "Clause 8: Operation",
    domain: "Technological",
    controlObjective: "Access control",
    controlStatement: "Rules to control physical and logical access to information and other associated assets shall be established and implemented.",
    implementationGuidance: "Implement RBAC, joiner/mover/leaver controls and periodic reviews.",
    rbiMapping: "RBI-IAM-04",
    sebiMapping: "CSCRF-IAM-01",
    evidence: "Access matrix, IAM config, review attestations",
    auditMethod: "Sampling, access tests",
  },
  {
    controlId: "A.8.2",
    clause: "Clause 8: Operation",
    domain: "Technological",
    controlObjective: "Privileged access rights",
    controlStatement: "The allocation and use of privileged access rights shall be restricted and managed.",
    implementationGuidance: "Use PAM with vaulting, session recording, JIT access.",
    rbiMapping: "RBI-IAM-03",
    sebiMapping: "CSCRF-IAM-02",
    evidence: "PAM reports, session logs, rotation evidence",
    auditMethod: "Console walkthrough, sampling",
  },
  {
    controlId: "A.8.15",
    clause: "Clause 9: Performance Evaluation",
    domain: "Technological",
    controlObjective: "Logging",
    controlStatement: "Logs that record activities, exceptions, faults and other relevant events shall be produced, stored, protected and analysed.",
    implementationGuidance: "Centralize logs in SIEM with retention and integrity controls.",
    rbiMapping: "RBI-SOC-04",
    sebiMapping: "CSCRF-SEC-01",
    evidence: "Log source inventory, SIEM architecture, retention proof",
    auditMethod: "Retrieval drills, config review",
  },
  {
    controlId: "A.8.16",
    clause: "Clause 9: Performance Evaluation",
    domain: "Technological",
    controlObjective: "Monitoring activities",
    controlStatement: "Networks, systems and applications shall be monitored for anomalous behavior and deviations.",
    implementationGuidance: "Use SOC operations, continuous monitoring and tuned detection use cases.",
    rbiMapping: "RBI-SOC-01",
    sebiMapping: "CSCRF-SEC-02",
    evidence: "SOC runbooks, dashboards, MTTD/MTTR reports",
    auditMethod: "SOC observation, metric validation",
  },
];

export const ISO_TO_INDIA_CROSSMAP = [
  { isoControl: "A.5.1 Policies", rbiControl: "RBI-GOV-01", sebiControl: "CSCRF-GOV-01", certInControl: "-" },
  { isoControl: "A.5.15 Access Control", rbiControl: "RBI-IAM-04", sebiControl: "CSCRF-IAM-01", certInControl: "-" },
  { isoControl: "A.8.2 Privileged Access", rbiControl: "RBI-IAM-03", sebiControl: "CSCRF-IAM-02", certInControl: "-" },
  { isoControl: "A.8.15 Logging", rbiControl: "RBI-SOC-04", sebiControl: "CSCRF-SEC-01", certInControl: "CERT-15" },
  { isoControl: "A.8.16 Monitoring", rbiControl: "RBI-SOC-01", sebiControl: "CSCRF-SEC-02", certInControl: "CERT-15" },
];
